(function () {
  if (window.__swimCollectionGridInit) return;
  window.__swimCollectionGridInit = true;

  const SECTION_IDS = ['cart-drawer', 'cart-icon-bubble'];
  const SWIPE_THRESHOLD = 40;

  function getCartAddUrl() {
    const url = window.routes && window.routes.cart_add_url;
    if (!url) return '/cart/add.js';
    return url.endsWith('.js') ? url : `${url}.js`;
  }

  function renderSections(sections) {
    if (!sections) return;

    SECTION_IDS.forEach((id) => {
      const html = sections[id];
      if (!html) return;

      const target =
        document.getElementById(id) ||
        document.getElementById(`shopify-section-${id}`) ||
        document.querySelector(`[id*="${id}"]`);

      if (target) {
        target.innerHTML = html;
      }
    });
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    if (drawer) {
      drawer.setAttribute('open', '');
      drawer.removeAttribute('hidden');
    }
  }

  async function addVariantToCart(variantId, button) {
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: SECTION_IDS.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      renderSections(data.sections);
      openCartDrawer();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (error) {
      const productUrl = button.closest('.card-wrapper')?.querySelector('.card__heading a')?.href;
      if (productUrl) {
        window.location.href = productUrl;
      }
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  }

  function getCarouselSlides(carousel) {
    return Array.from(carousel.querySelectorAll('[data-swim-carousel-slide]'));
  }

  function getActiveSlideIndex(slides) {
    return slides.findIndex((slide) => slide.classList.contains('is-active'));
  }

  function showCarouselSlide(carousel, nextIndex) {
    const slides = getCarouselSlides(carousel);
    if (slides.length < 2) return;

    const normalizedIndex = (nextIndex + slides.length) % slides.length;

    slides.forEach((slide, index) => {
      const isActive = index === normalizedIndex;
      slide.classList.toggle('is-active', isActive);
      slide.toggleAttribute('hidden', !isActive);
    });
  }

  function stepCarousel(carousel, direction) {
    const slides = getCarouselSlides(carousel);
    if (slides.length < 2) return;

    const currentIndex = getActiveSlideIndex(slides);
    const baseIndex = currentIndex === -1 ? 0 : currentIndex;
    showCarouselSlide(carousel, baseIndex + direction);
  }

  function optionKeyForIndex(index) {
    return `option${Number(index) + 1}`;
  }

  function parseVariantsJson(scriptEl) {
    if (!scriptEl) return [];
    try {
      const parsed = JSON.parse(scriptEl.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function findVariantForColorAndSize(variants, colorOptionIndex, colorValue, sizeOptionIndex, sizeValue) {
    const colorKey = optionKeyForIndex(colorOptionIndex);
    const sizeKey = optionKeyForIndex(sizeOptionIndex);

    return (
      variants.find((variant) => {
        if (!variant || !variant.available) return false;
        if (String(variant[sizeKey]) !== String(sizeValue)) return false;
        if (colorOptionIndex < 0 || colorValue == null || colorValue === '') return true;
        return String(variant[colorKey]) === String(colorValue);
      }) || null
    );
  }

  function findVariantForColor(variants, colorOptionIndex, colorValue) {
    if (colorOptionIndex < 0 || colorValue == null || colorValue === '') {
      return variants.find((variant) => variant && variant.available) || variants[0] || null;
    }

    const colorKey = optionKeyForIndex(colorOptionIndex);
    return (
      variants.find((variant) => variant && variant.available && String(variant[colorKey]) === String(colorValue)) ||
      variants.find((variant) => variant && String(variant[colorKey]) === String(colorValue)) ||
      null
    );
  }

  function updateSizePickerForColor(card, variants, colorOptionIndex, colorValue) {
    const picker = card.querySelector('.swim-size-picker');
    if (!picker) return;

    const sizeOptionIndex = Number(picker.dataset.sizeOptionIndex);
    if (Number.isNaN(sizeOptionIndex) || sizeOptionIndex < 0) return;

    picker.querySelectorAll('.swim-size-picker__size').forEach((button) => {
      const sizeValue = button.dataset.sizeValue;
      const match = findVariantForColorAndSize(
        variants,
        colorOptionIndex,
        colorValue,
        sizeOptionIndex,
        sizeValue
      );

      if (match) {
        button.dataset.variantId = String(match.id);
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-unavailable');
      } else {
        button.dataset.variantId = '';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-unavailable');
      }
    });
  }

  function activateCarouselImage(carousel, imageId) {
    if (!carousel || imageId == null) return false;

    const slides = getCarouselSlides(carousel);
    const matchIndex = slides.findIndex((slide) => String(slide.dataset.imageId) === String(imageId));
    if (matchIndex === -1) return false;

    slides.forEach((slide, index) => {
      const isActive = index === matchIndex;
      slide.classList.toggle('is-active', isActive);
      slide.toggleAttribute('hidden', !isActive);
    });
    return true;
  }

  function applyFeaturedImageFallback(carousel, featuredImage) {
    if (!carousel || !featuredImage || !featuredImage.src) return;

    const activeSlide = carousel.querySelector('.swim-card-media__slide.is-active') || getCarouselSlides(carousel)[0];
    const img = activeSlide?.querySelector('img');
    if (!img) return;

    img.src = featuredImage.src;
    if (featuredImage.width) img.width = featuredImage.width;
    if (featuredImage.height) img.height = featuredImage.height;
    if (featuredImage.alt) img.alt = featuredImage.alt;
  }

  function updateCardLinks(card, productUrl, variantId) {
    if (!productUrl) return;

    let nextHref = productUrl;
    try {
      const url = new URL(productUrl, window.location.origin);
      if (variantId) {
        url.searchParams.set('variant', String(variantId));
      } else {
        url.searchParams.delete('variant');
      }
      nextHref = `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      nextHref = productUrl;
    }

    card.querySelectorAll('.card__heading a, .swim-card-media__link, .card__media-link').forEach((link) => {
      link.setAttribute('href', nextHref);
    });
  }

  function syncCardFromColorSelection(root) {
    const card = root.closest('.card-wrapper');
    if (!card) return;

    const colorOptionIndex = Number(root.dataset.colorOptionIndex);
    const checked = root.querySelector('input[type="radio"]:checked');
    const colorValue = checked ? checked.value : null;
    const variants = parseVariantsJson(root.querySelector('script[type="application/json"]'));
    const productUrl = root.dataset.url || '';
    const variant = findVariantForColor(variants, colorOptionIndex, colorValue);

    updateSizePickerForColor(card, variants, colorOptionIndex, colorValue);

    if (variant) {
      updateCardLinks(card, productUrl, variant.id);

      const carousel = card.querySelector('[data-swim-carousel]');
      const imageId = variant.featured_image && variant.featured_image.id;
      const activated = activateCarouselImage(carousel, imageId);
      if (!activated && variant.featured_image) {
        applyFeaturedImageFallback(carousel, variant.featured_image);
      }
    }
  }

  class CardVariantSelects extends HTMLElement {
    connectedCallback() {
      this.onChange = this.onChange.bind(this);
      this.addEventListener('change', this.onChange);
      syncCardFromColorSelection(this);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange(event) {
      if (!event.target.matches('input[type="radio"]')) return;
      syncCardFromColorSelection(this);
    }
  }

  if (!customElements.get('card-variant-selects')) {
    customElements.define('card-variant-selects', CardVariantSelects);
  }

  // Expose helpers for jsdom verification without opening cart paths.
  window.__swimCollectionGridTestUtils = {
    findVariantForColorAndSize,
    findVariantForColor,
    updateSizePickerForColor,
    activateCarouselImage,
    parseVariantsJson,
    syncCardFromColorSelection,
  };

  document.addEventListener('click', (event) => {
    const sizeButton = event.target.closest('.swim-size-picker__size');
    if (sizeButton) {
      if (sizeButton.disabled || sizeButton.classList.contains('is-unavailable')) return;

      const variantId = sizeButton.dataset.variantId;
      if (!variantId) return;

      event.preventDefault();
      addVariantToCart(variantId, sizeButton);
      return;
    }

    const prevButton = event.target.closest('.swim-card-media__arrow--prev');
    if (prevButton) {
      const carousel = prevButton.closest('[data-swim-carousel]');
      if (!carousel) return;

      event.preventDefault();
      event.stopPropagation();
      stepCarousel(carousel, -1);
      return;
    }

    const nextButton = event.target.closest('.swim-card-media__arrow--next');
    if (nextButton) {
      const carousel = nextButton.closest('[data-swim-carousel]');
      if (!carousel) return;

      event.preventDefault();
      event.stopPropagation();
      stepCarousel(carousel, 1);
    }
  });

  let touchStartX = 0;

  document.addEventListener(
    'touchstart',
    (event) => {
      const carousel = event.target.closest('[data-swim-carousel]');
      if (!carousel || getCarouselSlides(carousel).length < 2) return;
      touchStartX = event.changedTouches[0]?.clientX || 0;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      const carousel = event.target.closest('[data-swim-carousel]');
      if (!carousel || getCarouselSlides(carousel).length < 2) return;

      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const deltaX = touchEndX - touchStartX;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

      event.preventDefault();
      stepCarousel(carousel, deltaX < 0 ? 1 : -1);
    },
    { passive: false }
  );
})();
